document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".upsell-carousel", {
    grabCursor: true,
    slidesPerView: "auto",
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Only add these two lines to prevent click interference
    preventClicks: false,
    preventClicksPropagation: false,
    breakpoints: {},
  });

  // Your existing cart toggle code - unchanged
  var toggleCartCollection = document.querySelector(".toggle-cart-collection");
  var cartCollection = document.querySelector(".go-cart__collection");
  var cartDrawer = document.querySelector(".js-go-cart-drawer");

  if (toggleCartCollection) {
    toggleCartCollection.addEventListener("click", function () {
      if (cartCollection.hasAttribute("open")) {
        cartCollection.removeAttribute("open");
        cartDrawer.classList.remove("show-cart-collection");
      } else {
        cartCollection.setAttribute("open", "");
        cartDrawer.classList.add("show-cart-collection");
      }
    });
  }
});